// 确认关联事项和被关联事项
import { useMemo } from 'react';
import { Table } from 'antd';

import { ItemIcon } from 'components/common';
import { classnames } from 'lib/classnames';
import useI18n from 'lib/hooks/useI18n';
import { Item, ItemType } from 'lib/types/models';

import { Relation } from '../../type';

import styles from './index.module.less';

const cx = classnames(styles);
interface RelationConfirmParams {
  items: Item[];
  relation: Relation[];
}

const RelationConfirm: React.VFC<RelationConfirmParams> = ({ items, relation }) => {
  const { t } = useI18n();

  const columns = useMemo(() => {
    return [
      {
        title: t('pages.item.columns.name'),
        width: 200,
        dataIndex: 'name',
        key: 'name',
        ellipsis: true,
        render: (name, row) => (
          <div className={cx('operate-confirm-relation-table-title')}>
            <ItemIcon icon={row?.itemType.icon} label={name} />
          </div>
        ),
      },
      {
        title: t('pages.fields.columns.link.key'),
        width: 100,
        dataIndex: 'key',
        key: 'key',
        ellipsis: true,
        render: key => <span className={cx('operate-detail-column-name')}>{key}</span>,
      },
      {
        title: t('pages.fields.columns.link.workspace'),
        width: 130,
        dataIndex: 'workspace',
        key: 'workspace',
        render: workspace => <span className={cx('operate-detail-column-name')}>{workspace?.name}</span>,
        ellipsis: true,
      },
    ];
  }, [t]);

  return (
    <div className={cx('operate-confirm-wrap')}>
      <div className={cx('operate-confirm-series')}>
        <p className={cx('operate-confirm-title')}>
          {t('pages.itemsBatchOperate.columns.Relation.inward')}（{items.length}）
        </p>
        <div className={cx('operate-confirm-item-wrap')}>
          {items.map(item => (
            <div key={item.objectId} className={cx('operate-confirm-item-row')}>
              <ItemIcon icon={(item.itemType as ItemType)?.icon} />
              <span className={cx('operate-confirm-item-key')}>{item.key}</span>
              <span className={cx('operate-confirm-item-name')}>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
      <div className={cx('operate-confirm-series')}>
        <p className={cx('operate-confirm-title')}>
          {t('pages.itemsBatchOperate.columns.Relation.outward')}（{relation.map(data => data.list).flat().length}）
        </p>
        <div className={cx('operate-confirm-series-table')}>
          {relation.map(relationData => {
            const { name, objectId, list } = relationData;
            return (
              <div className={cx('operate-confirm-relation-wrap')} key={objectId}>
                <p className={cx('operate-confirm-relation-title')}>{`${name}（${list.length}）`}</p>
                <Table
                  className={cx('operate-relation-table')}
                  rowClassName={cx('operate-relation-item')}
                  columns={columns}
                  dataSource={list}
                  pagination={false}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RelationConfirm;
